import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {VoucherGenComponent} from './voucher-gen.component';

const routes: Routes = [
  {path: 'voucher/generator', component: VoucherGenComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class VoucherGenRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-gen/voucher-gen-routing.module.ts